import { buildProps as e, definePropType as o } from "./index601.js";
const t = e({
  to: {
    type: o([String, Object]),
    required: !0
  },
  disabled: Boolean
});
export {
  t as teleportProps
};
